export const QUILL_BLOCK_TAGS = new Set([
  'blockquote',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'p',
  'div',
  'ul',
  'ol',
  'pre',
]);

export const EMPTY_QUILL_DEFAULT_WRAPPERS = [
  '<p><br></p>',
  '<h1 class="pre"><br></h1>',
  '<div class="pre"><br></div>',
] as const;
